import { cn } from "@/libs/utils";
import { IconBaseType } from "@/v2-components/core/icon/type";

export default function HandDeviceIcon({ className }: IconBaseType) {
  return (
    <svg
      className={cn("w-4.5 h-4.5", className)}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8295 5.175H4.47055C4.1155 5.175 3.82502 4.88452 3.82502 4.52947V2.89552C3.82502 2.54047 4.1155 2.25 4.47055 2.25H10.8295C11.1845 2.25 11.475 2.54047 11.475 2.89552V4.52947C11.475 4.88452 11.1845 5.175 10.8295 5.175Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.37285 10.35C4.07158 10.35 3.82498 10.6108 3.82498 10.9296V13.725C3.82498 13.7914 3.827 13.8577 3.83105 13.9237C3.86008 14.3914 4.05965 14.8331 4.36678 15.187C4.60573 15.4625 4.94998 15.75 5.39998 15.75H9.89998C10.35 15.75 10.6942 15.4625 10.9334 15.187C11.2403 14.8331 11.4401 14.3914 11.4689 13.9237C11.473 13.8577 11.475 13.7914 11.475 13.725V10.35H4.37285Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0125 8.55C9.57758 8.55 9.225 8.19742 9.225 7.7625C9.225 7.32757 9.57758 6.975 10.0125 6.975C10.4474 6.975 10.8 7.32757 10.8 7.7625C10.8 8.19742 10.4474 8.55 10.0125 8.55ZM11.5259 6.075H3.77415C3.55478 6.075 3.375 6.25478 3.375 6.47415V9.05085C3.375 9.27023 3.55478 9.45 3.77415 9.45H11.5259C11.7452 9.45 11.925 9.27023 11.925 9.05085V6.47415C11.925 6.25478 11.7452 6.075 11.5259 6.075Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3753 13.7463L14.1857 11.9139C14.4669 11.6326 14.6251 11.2512 14.6251 10.8534V9.09056C14.6251 8.64574 14.3389 8.23039 13.9062 8.12644C13.3248 7.98649 12.806 8.42344 12.806 8.98144V9.90484C12.806 10.1496 12.606 10.3497 12.3612 10.3497"
        fill="currentColor"
      />
    </svg>
  );
}
